import React from 'react';
import Select from 'react-select';

// A simplified common filter component matching the UI in the screenshot.
const CommanFilters = ({
  filters = {},
  dropdowns = {},
  visibleFields = [],
  onFilterChange = () => {},
  onApplyFilters = () => {},
  onClearFilters = () => {},
}) => {
  return (
    <div
      className="card p-4 mb-3"
      style={{ 
        border: '1px solid #e3e6ef',
        borderRadius: '8px',
        margin: 'auto'
      }}
    >
      <div className="mb-3">
        <span className="h5 fw-bold" style={{ color: '#222' }}>Filter by</span>
      </div>

      <form
        className="row gx-3 gy-2 align-items-center"
        onSubmit={e => {
          e.preventDefault();
          onApplyFilters();
        }}
      >
        <div className='row'>
        {visibleFields.length === 0 || visibleFields.includes('status') ? (
        <div className="col-md-2">
          <label className="form-label small mb-1">User Status</label>
          <Select
            options={dropdowns.statuses || [
              { value: 'active', label: 'Active' },
              { value: 'inactive', label: 'Inactive' }
            ]}
            value={(dropdowns.statuses || []).find(opt => opt.value === filters.status) || null}
            onChange={selected => onFilterChange('status', selected ? selected.value : '')}
            placeholder="User Status"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
        ) : null}

        {visibleFields.length === 0 || visibleFields.includes('userCategory') ? (
        <div className="col-md-2">
          <label className="form-label small mb-1">User Category</label>
          <Select
            options={dropdowns.userCategories || []}
            value={(dropdowns.userCategories || []).find(opt => opt.value === filters.userCategory) || null}
            onChange={selected => onFilterChange('userCategory', selected ? selected.value : '')}
            placeholder="User Category"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
        ) : null}

        {visibleFields.length === 0 || visibleFields.includes('accountStatus') ? (
        <div className="col-md-2">
          <label className="form-label small mb-1">Account Status</label>
          <Select
            options={dropdowns.accountStatuses || [
              { value: 'Verified', label: 'Verified' },
              { value: 'Pending', label: 'Pending' },
              { value: 'Rejected', label: 'Rejected' }
            ]}
            value={(dropdowns.accountStatuses || []).find(opt => opt.value === filters.accountStatus) || null}
            onChange={selected => onFilterChange('accountStatus', selected ? selected.value : '')}
            placeholder="Account Status"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
        ) : null}

        {visibleFields.length === 0 || visibleFields.includes('dateRange') ? (
        <div className="col-md-2">
          <label className="form-label small mb-1">Date Range</label>
          <div className="d-flex gap-2">
            <input
              type="date"
              className="form-control"
              value={filters.startDate || ''}
              onChange={e => onFilterChange('startDate', e.target.value)}
            />
            <span className="align-self-center" style={{ fontSize: 13 }}>to</span>
            <input
              type="date"
              className="form-control"
              value={filters.endDate || ''}
              onChange={e => onFilterChange('endDate', e.target.value)}
            />
          </div>
        </div>
        ) : null}
      </div>
      <div className='row mt-3'>
        { (visibleFields.length === 0 || visibleFields.includes('client')) ? (
          <div className="col-md-2">
            <label className="form-label small mb-1">Client</label>
            <Select
              options={dropdowns.clients || []}
              value={(dropdowns.clients || []).find(opt => opt.value === filters.client) || null}
              onChange={selected => onFilterChange('client', selected ? selected.value : '')}
              placeholder="Client"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
        ) : null}

        { (visibleFields.length === 0 || visibleFields.includes('state')) ? (
          <div className="col-md-2">
            <label className="form-label small mb-1">State</label>
            <Select
              options={dropdowns.states || []}
              value={(dropdowns.states || []).find(opt => opt.value === filters.state) || null}
              onChange={selected => onFilterChange('state', selected ? selected.value : '')}
              placeholder="State"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
        ) : null}

        { (visibleFields.length === 0 || visibleFields.includes('city')) ? (
          <div className="col-md-2">
            <label className="form-label small mb-1">City</label>
            <Select
              options={dropdowns.cities || []}
              value={(dropdowns.cities || []).find(opt => opt.value === filters.city) || null}
              onChange={selected => onFilterChange('city', selected ? selected.value : '')}
              placeholder="City"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
        ) : null}

        { (visibleFields.length === 0 || visibleFields.includes('country')) ? (
          <div className="col-md-2">
            <label className="form-label small mb-1">Country</label>
            <Select
              options={dropdowns.countries || []}
              value={(dropdowns.countries || []).find(opt => opt.value === filters.country) || null}
              onChange={selected => onFilterChange('country', selected ? selected.value : '')}
              placeholder="Country"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
        ) : null}
        { (visibleFields.length === 0 || visibleFields.includes('group')) ? (
          <div className="col-md-2">
            <label className="form-label small mb-1">Group</label>
            <Select
              options={dropdowns.groups || []}
              value={(dropdowns.groups || []).find(opt => opt.value === filters.group) || null}
              onChange={selected => onFilterChange('group', selected ? selected.value : '')}
              placeholder="Group"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
        ) : null}

        { (visibleFields.length === 0 || visibleFields.includes('category')) ? (
          <div className="col-md-2">
            <label className="form-label small mb-1">Category</label>
            <Select
              options={dropdowns.categories || []}
              value={(dropdowns.categories || []).find(opt => opt.value === filters.category) || null}
              onChange={selected => onFilterChange('category', selected ? selected.value : '')}
              placeholder="Category"
              isClearable
              classNamePrefix="react-select"
            />
          </div>
        ) : null}
      </div>

        <div className="col-12 mt-4 d-flex justify-content-center gap-2">
          <button
            className="btn btn-primary"
            type="submit"
            style={{ minWidth: 120, borderRadius: "6px" }}
          >
            Apply Filter
          </button>
          <button
            className="btn btn-secondary"
            type="button"
            style={{ minWidth: 120, borderRadius: "6px" }}
            onClick={() => {
              onClearFilters();
            }}
          >
            Clear
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommanFilters;